import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useIdle } from "react-use";

import { useLogout } from "@/hooks/useLogout";

import { StillBrowsingModal } from "./StillBrowsingModal";

type InactivityMonitorProps = {
  inactivityDuration: number;
};

const INACTIVITY_DURATION_AFTER_SHOW_MODAL = 1;

export const InactivityMonitor = ({
  inactivityDuration = 15,
}: InactivityMonitorProps) => {
  const [showModal, setShowModal] = useState(false);
  const isInactive = useIdle(inactivityDuration * 60 * 1000);

  const { isAuthenticated } = useAuth0();
  const { logout } = useLogout();
  const { t } = useTranslation();

  useEffect(() => {
    if (isInactive && isAuthenticated) {
      setShowModal(true);
      const timeoutId = setTimeout(
        () =>
          logout({
            returnTo: "/inactivity-logout",
          }),
        INACTIVITY_DURATION_AFTER_SHOW_MODAL * 60 * 1000,
      );
      return () => clearTimeout(timeoutId);
    }
  }, [isInactive, isAuthenticated, logout]);

  return (
    showModal && (
      <StillBrowsingModal
        header={t("global_stillBrowsingModal_header")}
        body={t("global_stillBrowsingModal_body")}
        continueButtonLabel={t("global_stillBrowsingModal_continueButton")}
        onClickContinue={() => setShowModal(false)}
        logoutButtonLabel={t("global_stillBrowsingModal_logoutButton")}
        onClickLogout={() => void logout({ returnTo: "/" })}
        showModal={showModal}
      />
    )
  );
};
